import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { toCreditCostRequestPayload } from './mappers/creditCostQuoteMapper';
import type { CreditCostQuoteResponse, CreditCostRequest } from './types';

type GetCreditCostQuoteProps = {
  artistId: string;
  request: CreditCostRequest;
};

// A list is sent as a repeated key (content_ids=a&content_ids=b), which the server reads as an array.
const toQueryString = (payload: Record<string, string | string[]>): string => {
  const params = new URLSearchParams();
  Object.entries(payload).forEach(([key, value]) => {
    (Array.isArray(value) ? value : [value]).forEach((item) => params.append(key, item));
  });
  return params.toString();
};

export const getCreditCostQuote = async ({ artistId, request }: GetCreditCostQuoteProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const query = toQueryString(toCreditCostRequestPayload(request));
  const url = `/web/studio/artists/${artistId}/credits/quote?${query}`;

  const response = await api.executeGetRequest<ObjectResponse<CreditCostQuoteResponse>>(url);

  return response.data;
};
